import './instrument';
import './dom-translation-guard';
import './chunk-load-reload';
import { createRoot } from 'react-dom/client';
import './i18n';
import { applyTenantOverrides } from '~tenants';
import { App } from './app';

applyTenantOverrides();

const root = document.getElementById('root');
if (!root) throw new Error('No root element found');

createRoot(root).render(<App />);
